export default "__VITE_ASSET__DBcVkzVG__"